// import http from '@core/api/client'

export default {
  log: (params) => console.log(...params)
}
